<template>
  <div :class="isH5 ? 'mobile-joint-purchase' : 'pc-joint-purchase'">
    <div class="content-wrap" @click="jumpJointPurchase">
      <div class="content-left">
        <img
          class="joint-icon"
          src="../../../assets/images/joint-purchase/joint-purchase-icon.png"
          alt=""
        />
        <div class="info-wrap">
          <p class="name">{{ jointInfo.title }}</p>
          <p class="time">
            {{
              moment(jointInfo.begin_at * 1000).format("YYYY.MM.DD HH:mm") +
              "-" +
              moment(jointInfo.end_at * 1000).format("YYYY.MM.DD HH:mm")
            }}
          </p>
        </div>
      </div>
      <img
        class="arrow-icon"
        src="../../../assets/images/joint-purchase/joint-arrow-icon.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { isH5 } from "@saas/components/src";
export default {
  props: {
    jointInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      moment,
    };
  },
  methods: {
    jumpJointPurchase() {
      //线索渠道参数
      let { course_id, lesson_id } = this.$route.query;
      let query = {};
      if (course_id) {
        query.course_id = course_id;
        query.lesson_id = lesson_id;
      }
      this.$router.push({
        name: "JointPurchase",
        params: {
          union_id: this.jointInfo.id,
        },
        query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-joint-purchase {
  --product-joint-bg: var(--mg-bg-card);
  --product-joint-card-bg: transparent;
  --product-joint-primary: var(--mg-text-primary);
  --product-joint-secondary: var(--mg-text-secondary);

  html.dark & {
    --product-joint-bg: var(--mg-bg-card);
    --product-joint-primary: var(--mg-text-primary);
    --product-joint-secondary: var(--mg-text-secondary);
  }

  background: var(--product-joint-bg);
  padding: 16px 0 0 0;
  .content-wrap {
    cursor: pointer;
    .content-left {
      display: flex;
      align-items: center;
    }
    .joint-icon {
      width: 38px;
      height: 16px;
      margin-right: 16px;
    }
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 768px;
    height: 46px;
    background: url("../../../assets/images/joint-purchase/joint-bg-pc.png");
    filter: brightness(0.7) contrast(1.1);
    background-size: 100% 100%;
    border-radius: 8px;
    margin: 0 auto;
    padding: 0 20px 0 16px;
    .info-wrap {
      display: flex;
      align-items: center;
      .name {
        font-size: 16px;
        color: #0d1400;
        line-height: 22px;
        margin-right: 16px;
      }
      .time {
        font-size: 14px;
        color: var(--product-joint-secondary);
        line-height: 20px;
      }
    }
    .arrow-icon {
      width: 16px;
      height: 16px;
    }
  }
}
.mobile-joint-purchase {
  --product-joint-bg: var(--mg-bg-card);
  --product-joint-primary: var(--mg-text-primary);
  --product-joint-secondary: var(--mg-text-secondary);

  html.dark & {
    --product-joint-bg: var(--mg-bg-card);
    --product-joint-primary: var(--mg-text-primary);
    --product-joint-secondary: var(--mg-text-secondary);
  }

  background: var(--product-joint-bg);
  padding: 0 0.27rem 0.35rem;
  .content-wrap {
    margin: 0 auto;
    width: 9.44rem;
    height: 1.23rem;
    background: url("../../../assets/images/joint-purchase/join-bg-h5.png");
    background-size: 100% 100%;
    padding: 0 0.21rem 0 0.32rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .arrow-icon {
      width: 0.43rem;
      height: 0.43rem;
    }
  }
  .content-left {
    display: flex;
    align-items: center;
    .joint-icon {
      width: 1.01rem;
      height: 0.43rem;
      margin-right: 0.27rem;
    }
    .info-wrap {
      .name {
        font-size: 0.43rem;
        color: var(--product-joint-primary);
        line-height: 0.59rem;
      }
      .time {
        font-size: 0.37rem;
        color: var(--product-joint-secondary);
        line-height: 0.53rem;
      }
    }
  }
}

</style>
